<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>

        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <input id="search" v-model="filter.search" type="text" class="form-control" placeholder="Search...">
                </div>
            </div>
            <div class="col-md-6" />
            <div class="col-md-2">
                <b-button id="create" variant="primary" class="btn-block" @click="$router.push({ name: 'banner.create' })">
                    Create
                </b-button>
            </div>
        </div>

        <b-card class="mt-2" title="Filter">
            <b-row>
                <b-col sm="12" md="4" v-if="!userData.partner && userData.role === 'admin'">
                    <div class="form-group">
                        <label for="partner">Partner</label>
                        <v-select id="partner" v-model="filter.partner" :options="options.optionsPartner"
                            :reduce="item => item.uuid" label="name" placeholder="Type to search Partner..."
                            @search="onSearchPartner">
                            <template slot="no-options">
                                Type here to search partner...
                            </template>
                        </v-select>
                    </div>
                </b-col>

                <b-col sm="12" md="4">
                    <div class="form-group">
                        <label for="status">Status</label>
                        <b-form-select :options="options.optionsStatus" id="status" v-model="filter.is_active"
                            class="form-control" />
                    </div>
                </b-col>

                <b-col sm="12" md="4">
                    <FormSelect id="location" label="Location" v-model="filter.location" :modelValue="filter.location"
                    :options="options.location" :validation="validations.location" />
                </b-col>
            </b-row>
        </b-card>

        <b-card-code no-body>
            <div class="table-responsive-sm">
                <table class="table b-table table-fixed">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Location</th>
                            <th>Partner</th>
                            <th>Is Active</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="isLoading">
                            <td colspan="5" class="text-center">
                                <b-spinner label="Loading..." variant="primary" />
                            </td>
                        </tr>
                        <template v-if="!isLoading">
                            <tr v-for="item, index in result.items" :key="index">
                                <td>{{ item.title || '-' }}</td>
                                <td>{{ item.location || '-' }}</td>
                                <td>{{ item.partner && item.partner.name || '-' }}</td>
                                <td>
                                    <b-badge class="text-capitalize" :variant="item.is_active ? 'success' : 'danger'">
                                        {{ item.is_active }}
                                    </b-badge>
                                </td>
                                <td class="text-right">
                                    <div class="btn-group" role="group" aria-label="Basic example">

                                        <b-button id="edit" variant="info" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Edit"
                                            @click="$router.push({ name: 'banner.update', params: { id: item._id } })">
                                            <feather-icon icon="EditIcon" />
                                        </b-button>

                                        <b-button id="delete" variant="danger" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Delete"
                                            @click="deleteItem(item._id)">
                                            <feather-icon icon="Trash2Icon" />
                                        </b-button>

                                    </div>
                                </td>
                            </tr>
                            <tr v-if="totalItems == 0">
                                <td colspan="5" class="text-center">
                                    Data is empty.
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="row mt-1 mx-0">
                    <div class="col-6 pl-2">
                        <small>Showing {{ Math.min(perPage * currentPage, totalItems) }} to {{ totalItems || 0 }} from
                            {{ totalRows || 0
                            }}
                        </small>
                    </div>
                    <div class="col-6 pr-2">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right"
                            size="sm" class="my-0" />
                    </div>
                </div>
            </div>
        </b-card-code>

    </div>
</template>

<script>
import _ from 'lodash'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    BCard, BCardText, BButton, BSpinner, BPagination, BFormInput, BFormGroup, BFormCheckbox, BFormSpinbutton, BImg, BBadge, BRow, BCol, BFormSelect
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'

import { successNotification, errorNotification } from '@/auth/utils'
import vSelect from 'vue-select'
import FormSelect from '@/components/FormSelect.vue'
export default {
    title() {
        return 'Banner Management'
    },
    components: {
        BCard,
        BButton,
        BCardText,
        BCardCode,
        BSpinner,
        BPagination,
        BFormInput,
        BFormGroup,
        BFormCheckbox,
        BFormSpinbutton,
        BImg,
        BBadge,
        BRow,
        BCol,
        vSelect,
        BFormSelect,
        FormSelect
    },
    directives: {
        Ripple,
    },
    setup() {
        return { successNotification, errorNotification }
    },
    mixins: [heightTransition],
    watch: {
        currentPage: {
            handler: _.debounce(function (value) {
                this.getData(value);
            }, 300),
            deep: true,
        },
        filter: {
            handler: _.debounce(function (value) {
                this.getData();
            }, 300),
            deep: true,
        }
    },
    data() {
        const userData = JSON.parse(localStorage.getItem('userData'))
        return {
            userData,
            // Pagination
            currentPage: 1,
            totalRows: 0,
            perPage: 10,
            itemCount: 0,
            totalItems: 0,
            pageOptions: [3, 5, 10],

            result: Object,
            isLoading: false,
            editId: null,
            filter: {
                search: '',
                partner: userData && userData.partner ? userData.partner._id : null,
                content_type: null,
                is_active: null,
                location: null
            },
            validations: {},
            options: {
                optionsAuthor: [],
                optionsPartner: [],
                optionsCategory: [],
                optionsStatus: [
                    {
                        value: null,
                        text: 'Choose status',
                    },
                    {
                        value: 'true',
                        text: 'Active',
                    },
                    {
                        value: 'false',
                        text: 'Non-active',
                    },
                ],
                optionsContentType: [
                    {
                        value: null,
                        text: 'Choose content type',
                    },
                    {
                        value: 'standard',
                        text: 'Standard',
                    },
                    {
                        value: 'video',
                        text: 'Video',
                    },
                ],
                location: [
                    { value: null, text: 'Please select an option' },
                    { value: 'homepage-parallax-ads', text: 'Homepage Parallax Ads' },
                    { value: 'homepage-ads-below-header', text: 'Homepage Ads Below Header' },
                    { value: 'homepage-ads-above-trending-now', text: 'Homepage Ads Above Trending Now' },
                    { value: 'homepage-ads-above-popular-article', text: 'Homepage Ads Above Popular Article' },
                    { value: 'homepage-ads-above-latest-article', text: 'Homepage Ads Above Latest Article' },
                    { value: 'homepage-ads-above-footer', text: 'Homepage Ads Above Footer' },
                    { value: 'detail-article-parallax-ads', text: 'Detail Article Parallax Ads' },
                    { value: 'detail-article-ads-above-article', text: 'Detail Article Ads Above Article' },
                    { value: 'detail-article-ads-above-trending-now', text: 'Detail Article Ads Above Trending Now' },
                    { value: 'detail-article-ads-above-next-article', text: 'Detail Article Ads Above Next Article' },
                    { value: 'detail-article-ads-above-footer', text: 'Detail Article Ads Above Footer' },
                ],
            },
        }
    },
    mounted() {
        this.getData()
        this.getPartner()
    },
    created() {
    },
    destroyed() {
    },
    methods: {
        // Partner
        onSearchPartner(search, loading) {
            if (search.length) {
                loading(true)
                this.searchPartner(loading, search, this)
            }
        },
        searchPartner: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/partners?&search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.optionsPartner = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getPartner() {
            if (this.userData.role == 'admin') {
                this.$http.get('/admin/partners', {
                }).then((result) => {
                    this.options.optionsPartner = result.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                }).catch((err) => {

                });
            }
        },
        getData(page = 1) {
            this.isLoading = true
            this.currentPage = page
            const queryParams = this.filter
            queryParams.page = this.currentPage

            this.$http.get('/admin/ads', {
                params: queryParams,
            })
                .then(response => {
                    const data = response.data.data;
                    this.result = data;
                    this.itemCount = data.meta.item_count;
                    this.totalItems = data.meta.total_items;
                    this.currentPage = data.meta.current_page;
                    this.totalRows = data.meta.total_items;
                    this.isLoading = false;
                })
        },
        deleteItem(id) {
            this.$swal({
                title: 'Are you sure?',
                text: 'Are you sure to delete this ads?',
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.$http.delete(`admin/ads/${id}`)
                        .then(response => {
                            this.getData(this.currentPage)
                            this.$swal({
                                icon: 'success',
                                title: 'Success!',
                                text: 'Ads successfully deleted',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                            })
                        })
                        .catch(error => {
                            const validations = error.response.data.meta.validations
                            // this.validations = validations
                            for (const key in validations) {
                                if (validations.hasOwnProperty(key)) {
                                    errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                                }
                            }
                        })
                }
            })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
    overflow: hidden;
    transition: .35s height;
}
</style>
